<template>
  <div class="alert-container">
    <v-alert
      v-for="notification in notifications"
      :key="notification.id"
      dismissible
      :v-model="notification"
      :value="true"
      :type="notification.type"
      @click="dismissAlert(notification, $event)"
    >{{ notification.message }}</v-alert>
  </div>
</template>

<script>
export default {
  name: "AlertContainer",
  computed: {
    notifications() {
      return this.$store.state.notifications;
    }
  },
  methods: {
    dismissAlert(notificationToDelete, $event) {
      if ($event.target.tagName === "I" || $event.target.tagName === "A") {
        this.$store.dispatch("deleteNotification", notificationToDelete);
      }
    }
  }
};
</script>

<style scoped>
.alert-container {
  position: fixed;
  width: 100%;
  z-index: 1000;
}
</style>